import ApiService from "../apiService";
import { get } from "../apiService";
const _ = require("lodash");

export default class HistoryService extends ApiService {
  findAll(model, id) {
    return get(`/${model}/${id}/history`, {
      params: {}
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/historyService/index.js